/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { inject } from "mobx-react";
import { getSelectedRateIndex, getVoiceRateList } from "selectors/readAloudSelectors";
import { ReadAloudPicker } from "components/readAloud/ReadAloudPicker";
import { trackReadAloudVoiceRateChange } from "analytics/events";

const mapStoresToProps = stores => {
  const voiceRateList = getVoiceRateList(stores),
    selectedRateIndex = getSelectedRateIndex(stores);

  const buttonLabel = `${voiceRateList[selectedRateIndex]}x`;
  const voiceRateOptions = voiceRateList.map((rate, id) => ({
    id,
    label: `${rate}x`,
    selected: id === selectedRateIndex
  }));
  const menuStyle = { width: "101px" };
  return {
    options: voiceRateOptions,
    dropdownClassName: "ratePickerIcon",
    menuStyle,
    selectHandler: value => {
      stores.readAloudStore.setSelectedRateIndex(value);
      if (selectedRateIndex !== value) trackReadAloudVoiceRateChange();
    },
    tooltip: "tooltip.readAloudRate",
    arialabel: "arialabel.readAloudRate",
    icon: buttonLabel
  };
};

export const ReadAloudRatePickerContainer = inject(mapStoresToProps)(ReadAloudPicker);
